/**
 * rejectedApiError — РАЗБОР ОТВЕРГНУТОГО ДЕЙСТВИЯ, одна дверь на все слайсы
 * (WEB-1955, хвост волны локализации WEB-1874).
 *
 * ЗАЧЕМ. Редьюсер `rejected` писал в состояние ТЕКСТ отказа — либо пейлоад,
 * приведённый к строке (`action.payload as string`), либо текст самой ошибки
 * (`action.error.message ?? 'Failed to fetch domains'`). Обе формы теряют
 * КОД, а фразу на языке кабинета `localizeError` выбирает именно по коду:
 * англоязычный человек читал русский отказ сервера, русскому доставался
 * зашитый в слайс английский запасной текст.
 *
 * ПРАВИЛО ТЕПЕРЬ ОДНО: в состоянии слайса лежит РАЗОБРАННЫЙ отказ
 * (`ApiErrorInfo` — статус, текст, код, причина), а фразу человеку выбирает
 * экран: `localizeError(info, s.запаснаяФраза)`. Запасной текст — строка
 * ЭКРАНА из его словаря (пара ru/en), а не английская константа слайса.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ КОПИЯ В КАЖДОМ СЛАЙСЕ (CLAUDE.md, WEB-1844):
 * правило с шестнадцатью местами применения разъедется редакциями. И второе:
 * здесь нет ни одного чтения `.message` — код отказа не разбирается руками, а
 * отдаётся общему разборщику `extractApiError`, который знает обе формы
 * отказа (сырой axios и сплющенный перехватчиком Error).
 */
import { extractApiError, type ApiErrorInfo } from '@/api/errorStatus';

/** Часть отвергнутого действия Redux Toolkit, которая нужна для разбора. */
export interface RejectedActionLike {
  readonly payload?: unknown;
  readonly error?: unknown;
}

/**
 * Причина отказа в разобранном виде.
 *
 * Порядок источников: сперва ПЕЙЛОАД (его положил тханк — там живой отказ
 * сервера со статусом и кодом), и только если тханк не отверг своим пейлоадом
 * (например, исключение выброшено до `rejectWithValue` или действие отменено)
 * — `action.error`, сериализованная Redux Toolkit ошибка.
 */
export function rejectedApiError(action: RejectedActionLike): ApiErrorInfo {
  const { payload } = action;
  if (payload !== undefined && payload !== null) return extractApiError(payload);
  return extractApiError(action.error);
}
